import { createValidator } from 'revalidate';
import { TERMS_AND_CONDITIONS_NOT_ACCEPTED } from '../constants/defaultErrorMessages';
const isConditionsAccepted = createValidator(message => value => value !== undefined && value ? null : message || TERMS_AND_CONDITIONS_NOT_ACCEPTED, TERMS_AND_CONDITIONS_NOT_ACCEPTED);
export default isConditionsAccepted;
//# sourceMappingURL=isConditionsAccepted.js.map